import { useTranslation } from 'react-i18next'
import { SSN_SE_SECTION_ID } from '@/components/PriceCalculator/SsnSeSection'
import { Button } from 'ui/src/components/Button/Button'
import { useActiveFormSectionId } from '../../useActiveFormSectionId'
import { usePriceCalculatorForm } from '../../usePriceCalculatorForm'
import { usePriceCalculatorStep } from '../../usePriceCalculatorStep'

export function OfferEditButton() {
  const { t } = useTranslation('cart')

  const { setStep } = usePriceCalculatorStep()
  const { setActiveFormSectionId } = useActiveFormSectionId()
  const form = usePriceCalculatorForm()

  const handleEditClick = () => {
    const targetSectionId = form.sections.find((section) => section.id !== SSN_SE_SECTION_ID)!.id

    setActiveFormSectionId(targetSectionId)
    setStep('fillForm')
  }

  return (
    <Button variant="secondary" size="medium" fullWidth={true} onClick={handleEditClick}>
      {t('EDIT_INFORMATION_BUTTON_LABEL')}
    </Button>
  )
}
